import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const TaskItemWrapper = styled.div`
	// padding-left: calc(100vw*(42/375));
	&:after{
		clear: both;
		display: block;
		content: " ";
	}
	display: flex;
	align-items: center;
	padding-top: calc(100vw*(9/375));
    padding-bottom: calc(100vw*(9/375));
`;
export const ItemLeft = styled.div`
	width : calc(100vw*(42/375));
	height : calc(100vw*(42/375));
	float: left;
	border-radius: 100%;
	display: inline-block;
`;

// export const ItemLeftLink = styled(Link)`
// 	// width : calc(100vw*(42/375));
// 	// height : calc(100vw*(42/375));
// 	// margin-left: calc(100vw*(-42/375));
//     // display: flex;
// 	// align-items: center;
// 	// justify-content: center;
//     // // overflow: hidden;
//     // // box-shadow: 0px 2px 8px rgba(255, 220, 89, 0.88);
//     // border-radius:100%;
// `;

const itemLeftStyle = css`
	display: flex;
	align-items: center;
	justify-content: center;
	width : calc(100vw*(42/375));
	height : calc(100vw*(42/375));
	border-radius:100%;
	overflow: hidden;
`;

export const ItemLeftWhiteBlock = styled.div`
	${itemLeftStyle}
	background: #FFF;
	
`;

export const ItemLeftActiveBlock = styled.div`
	${itemLeftStyle}
	background: #FFCF19;
	box-shadow: 0px 2px 8px rgba(255, 220, 89, 0.88);
`;

export const ItemLeftBlock = styled.div`
	${itemLeftStyle}
	background: #D5D5D5;
`;

export const ItemLeftCompleteImgBlock = styled.div`
	width: calc(100vw*(25/375));
	height: calc(100vw*(17/375));
`;

export const ItemLeftFailImgBlock = styled.div`
	width: calc(100vw * (23 / 375));
	height: calc(100vw * (23 / 375));
`;

export const ItemLeftCamaraImgBlock = styled.div`
	width: calc(100vw * (21 / 375));
	height: calc(100vw * (17 / 375));
`;

export const ItemLeftImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`;

export const ItemRight = styled.div`
	width : 100%;
	padding-left: calc(100vw*(15/375));
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
export const TaskInfoWrapper = styled.div`
	display: inline-block;
	width: 90%;
`;

export const TaskInfoLinkWrapper = styled(Link)`
	display: inline-block;
	width: 90%;
`;
export const TaskTitle = styled.span`
	font-size: calc(100vw*(14/375));
	line-height: calc(100vw*(20/375));
	display: inline-block;
	width: 100%;
	white-space: pre-wrap;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
`;

export const TaskTime = styled.span`
	font-size: calc(100vw*(12/375));
	line-height: calc(100vw*(17/375));
	display: inline-block;
	color: #7F7F7F;
`;